import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { AppLogo, AppLogoSvg } from "./Strings";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import { primaryColor } from "./Theme";

export default function MediaCard({ data }) {
  const history = useHistory();
  function handleClick() {
    history.push(data.path);
  }

  return (
    <Card sx={{ maxWidth: 250 }}>
      <Box sx={{ backgroundColor: primaryColor }}>
        <CardMedia
          component="img"
          height="140"
          image={AppLogoSvg}
          sx={{ objectFit: "contain" }}
        />
      </Box>

      <CardContent>
        <Typography gutterBottom variant="h6" component="div">
          {data.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {data.desc}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={handleClick}>
          See more
        </Button>
      </CardActions>
    </Card>
  );
}
